
import { defineComponent, nextTick, PropType, ref, watch } from "vue";
import { ElCol, ElForm, ElFormItem, ElRow, ElDatePicker } from 'element-plus'
import ElSelectExt from '@/components/ElSelectExt.vue'

const componentMap: any = {
  ElSelectExt,
  ElDatePicker
}

export default defineComponent({
  name: 'DynamicFormInJson',
  components: {
    ElForm,
    ElFormItem,
    ElRow,
    ElCol
  },
  props: {
    model: {
      type: Object as PropType<Record<string, any>>,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      default: -1
    },
    labelWidth: {
      type: String,
      default: '120px'
    },
    rows: {
      type: Array as PropType<any[][]>,
      required: true
    },
    columns: {
      type: Array as PropType<any[]>,
      required: true,
    },
    roleIds: {
      type: Array as PropType<number[]>,
      required: true
    },
    gutter: {
      type: Number,
      default: 20
    },
    justify: {
      type: String,
      default: 'space-between'
    },
    colSpan: {
      type: Number,
      default: 8
    }
  },
  emits: ['update:model'],
  setup(props, { emit }) {
    const formModel = ref({ ...props.model })
    const formRef = ref<InstanceType<typeof ElForm> | null>(null)

    watch(
      formModel,
      (newModel) => {
        if (newModel) {
          if (props.index == -1) {
            handleUpdate(newModel)
          } else {
            handleUpdate(newModel, props.index)
          }
        }
      },
      { deep: true, immediate: false }
    )

    const formatRules = (item: any) => {
      const result = JSON.parse(item.componentOptions)
      if (result) {
        result.type = result.searchType
        return result.rules ? result.rules : []
      } else {
        return []
      }
    }

    const validateForm = () => {
      return new Promise((resolve, reject) => {
        formRef.value?.validate((valid: any) => {
          if (valid) {
            resolve(true)
          } else {
            nextTick(() => {
              const errorEl: any = document.querySelector('.el-form-item__error')
              if (errorEl) {
                scrollToError(errorEl)
              }
            })
            reject(false)
          }
        })
      })
    }

    const scrollToError = (el: HTMLElement) => {
      el.scrollIntoView({ behavior: 'smooth' });
    }

    const getComponent = (item: any) => {
      console.log(111111111111)
      const componentName = item.component
      const component = componentMap[componentName]
      if (!component) {
        return componentName
      }
      return component
    }

    const formatOptions = (item: any) => {
      return JSON.parse(item.componentOptions)
    }

    const formatViewValue = (item: any) => {
      if(formModel.value[item.columnName]) {
        const result = JSON.parse(item.componentOptions)
        if (result && result.format) {
          return result.options.find((o: any) => o.value == formModel.value[item.columnName])?.label
        } else {
          if(formModel.value[item.columnName] instanceof Array) {
            return formModel.value[item.columnName].join('+')
          } else {
            return formModel.value[item.columnName]
          }
        }
      } else {
        return '暂无数据'
      }
    }

    const handleUpdate = (value: Record<string, any>, index?: number) => {
      emit('update:model', value, index)
    }

    return {
      formRef,
      formModel,
      formatRules,
      getComponent,
      formatOptions,
      formatViewValue,
      handleUpdate,
      scrollToError,
      validateForm
    }
  }
})
